import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const EconomicDrivingPage = lazy(() => import('../pages/EconomicDrivingPage'));
const EconomicDrivingDashboardPage = lazy(() => import('../pages/EconomicDrivingDashboardPage'));
const EconomicDrivingReportPage = lazy(() => import('../pages/EconomicDrivingReportPage'));

export interface IRoute {
  path: string;
  team?: string;
  component: any;
  accessDeniedDescription: string;
  routes?: IRoute[];
  exact?: boolean;
}

const routes = [
  {
    path: Location.ECONOMIC_DRIVING,
    team: 'squad-gf-core',
    component: EconomicDrivingPage,
    accessDeniedDescription: 'ver condução econômica',
    routes: [
      {
        path: Location.ECONOMIC_DRIVING_DASHBOARD,
        component: EconomicDrivingDashboardPage,
        accessDeniedDescription: 'ver condução econômica',
        exact: true,
      },
      {
        path: Location.ECONOMIC_DRIVING_TYPE,
        component: EconomicDrivingReportPage,
        accessDeniedDescription: 'ver condução econômica',
        exact: true,
      },
    ],
  },
];

export default routes;
